"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const ChevronLeftIcon_1 = __importDefault(require("../icons/ChevronLeftIcon"));
const styles_1 = require("../styles");
const ButtonBase_1 = __importDefault(require("./ButtonBase"));
const Card_1 = __importDefault(require("./Card"));
const CardCaption_1 = __importDefault(require("./CardCaption"));
const CardContainer_1 = __importDefault(require("./CardContainer"));
const Image_1 = __importDefault(require("./Image"));
const Text_1 = __importDefault(require("./Text"));
const ItemCard = ({ title, titleMarginBottom = 'default', children, hasChevron = true, inHeader = false, image, defaultImage, imageProps: { variant = 'outlined', resizeMode = 'contain' } = {}, caption, captionInHeader = false, statusBadge, screenName, params, }) => {
    const [imageSize, setImageSize] = react_1.useState(53);
    const [imageSizeIsSet, setImageSizeIsSet] = react_1.useState(false);
    return (react_1.default.createElement(Card_1.default, { style: react_native_1.StyleSheet.flatten([
            { marginHorizontal: inHeader ? 0 : styles_1.getSpacing(), marginVertical: inHeader ? 0 : styles_1.getSpacing(0.5) },
        ]) },
        react_1.default.createElement(ButtonBase_1.default, { disabled: !hasChevron, screenName: screenName, params: params },
            caption && captionInHeader && (react_1.default.createElement(CardCaption_1.default, { color: "default" },
                react_1.default.createElement(react_native_1.View, { style: styles.rowView },
                    caption,
                    hasChevron && react_1.default.createElement(ChevronLeftIcon_1.default, { stroke: styles_1.Colors.primary })))),
            react_1.default.createElement(CardContainer_1.default, { style: styles.innerView },
                (!!image || !!defaultImage) && (react_1.default.createElement(Image_1.default, { variant: variant, style: react_native_1.StyleSheet.flatten([
                        {
                            height: imageSize,
                            width: imageSize,
                            marginEnd: styles_1.getSpacing(),
                        },
                    ]), resizeMode: resizeMode, source: { uri: image }, defaultSource: defaultImage })),
                react_1.default.createElement(react_native_1.View, { style: styles.flex, onLayout: (event) => {
                        const size = event.nativeEvent.layout.height;
                        if (size > imageSize && !imageSizeIsSet) {
                            setImageSize(size);
                            setImageSizeIsSet(true);
                        }
                    } },
                    !!title && (react_1.default.createElement(react_native_1.View, { style: styles.rowView },
                        react_1.default.createElement(Text_1.default, { variant: "cardTitle", color: "primary", numberOfLines: 1, style: styles.flex, margin: children ? titleMarginBottom : 'none' }, title),
                        statusBadge)),
                    children)),
            !!caption && !captionInHeader && (react_1.default.createElement(CardCaption_1.default, { color: "default" },
                react_1.default.createElement(react_native_1.View, { style: styles.rowView },
                    caption,
                    hasChevron && react_1.default.createElement(ChevronLeftIcon_1.default, { stroke: styles_1.Colors.primary })))))));
};
exports.default = ItemCard;
const styles = react_native_1.StyleSheet.create({
    innerView: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
    rowView: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
});
